export async function readCampaignResponse(response) {
  const text = await response.text();
  let data;
  try { data = JSON.parse(text); }
  catch (err) { data = null; }

  if (!response.ok) {
    const defaults = {
      429: 'Mailgun limitó los envíos. Revisa los límites de tu cuenta antes de volver a intentarlo.',
      422: 'Revisa los destinatarios, el asunto y la plantilla de la campaña.',
      504: 'No se pudo confirmar el envío. Revisa el estado de la campaña antes de volver a enviar.',
    };
    const error = new Error(data?.message || defaults[response.status] ||
      'No se pudo completar la campaña. Revisa su estado antes de volver a enviar.');
    error.campaign = {
      message: error.message,
      providerMessage: typeof data?.provider_message === 'string' ? data.provider_message : '',
      accepted: Number(data?.accepted) || 0,
      total: Number(data?.total) || 0,
      deliveryUnknown: !!data?.delivery_unknown || !data,
    };
    throw error;
  }
  // Older sender deployments returned the JSON number 200.
  if (data !== 200 && (!data || typeof data !== 'object')) {
    const error = new Error('El servidor respondió sin confirmar el resultado. Revisa el estado antes de volver a enviar.');
    error.campaign = { message: error.message, deliveryUnknown: true };
    throw error;
  }
  return data;
}
